import { ServiceLocationModel } from "../../../entities";
import { BaseODataRepository } from "../../BaseODataRepository";

export class ServiceLocationODataRepo extends BaseODataRepository<ServiceLocationModel> {
  protected baseUrl = `/odata/servicelocations`;
}

export default ServiceLocationODataRepo;
